import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import RadioButton from "app/components/common/buttons/RadioButton";

interface Props {
  control: Control<any>;
  errors: any;
  phoneNumber: string;
  landline: string;
  workNumber: string;
  email: string;
  preferredMethodOfContact: string;
  disabledEmailPhone?: boolean;
  disabledEmail?: boolean;
}

const DynamicFormThree: FC<Props> = ({
  control,
  errors,
  phoneNumber,
  landline,
  workNumber,
  email,
  preferredMethodOfContact,
  disabledEmailPhone = false,
  disabledEmail = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };

  return (
    <>
      <FormGroup>
        <InputField
          label="Mobile number"
          name={phoneNumber}
          control={control}
          type="number"
          required={true}
          placeholder="(307) 555-0133"
          error={getErrorMessage(phoneNumber)?.message as string}
          className="flex-1"
          rules={{
            required: "Phone number is required",
          }}
          disabled={disabledEmailPhone}
        />
        <InputField
          label="landline"
          name={landline}
          control={control}
          type="number"
          required={false}
          placeholder="(307) 555-0133"
          error={getErrorMessage(landline)?.message as string}
          className="flex-1"
          rules={{
            min: {
              value: 1,
              message: "value must be greater than 0",
            },
          }}
        />
      </FormGroup>
      <FormGroup>
        <InputField
          label="Work Number"
          name={workNumber}
          control={control}
          type="number"
          required={false}
          placeholder="(307) 555-0133"
          error={getErrorMessage(workNumber)?.message as string}
          className="flex-1"
          rules={{
            pattern: {
              value: /^[0-9]{11}$/,
              message: "Please enter a valid 11 digit phone number",
            },
          }}
        />
        <InputField
          label="Email"
          name={email}
          control={control}
          type="text"
          required={true}
          placeholder="caroline325@mail.com"
          error={getErrorMessage(email)?.message as string}
          className="flex-1"
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: "Invalid email format",
            },
          }}
          disabled={disabledEmailPhone || disabledEmail}
        />
      </FormGroup>
      <div className="text-left mb-5">
        <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-4">
          Preferred method of contact? <span className="text-red-500">*</span>
        </h6>
        <div className="flex gap-5">
          <Controller
            name={preferredMethodOfContact}
            control={control}
            rules={{ required: "Please select an option" }}
            render={({ field: { value, onChange } }) => (
              <div className="flex gap-5">
                <RadioButton
                  id={`${preferredMethodOfContact}_phone`}
                  name={preferredMethodOfContact}
                  value="phone"
                  label="Phone"
                  checked={value === "phone"}
                  onChange={onChange}
                />
                <RadioButton
                  id={`${preferredMethodOfContact}_email`}
                  name={preferredMethodOfContact}
                  value="email"
                  label="Email"
                  checked={value === "email"}
                  onChange={onChange}
                />
              </div>
            )}
          />
        </div>

        <ErrorsMessage
          title={getErrorMessage(preferredMethodOfContact)?.message as string}
          className="!text-left"
        />
      </div>
    </>
  );
};

export default DynamicFormThree;
